// extracted by mini-css-extract-plugin
export var accent = "_c2-4";
export var add = "_c2-j";
export var addIcon = "_c2-k";
export var deleteIcon = "_c2-i";
export var disabled = "_c2-9";
export var ellipsis = "_c2-f";
export var error = "_c2-3";
export var form = "_c2-5";
export var hideFocus = "_c2-2";
export var icon = "_c2-7";
export var input = "_c2-e";
export var listItem = "_c2-h";
export var mediumHeight = "_c2-b";
export var noBorder = "_c2-8";
export var noRadius = "_c2-1";
export var shortHeight = "_c2-a";
export var tallHeight = "_c2-c";
export var textInput = "_c2-0";
export var vertical = "_c2-g";
export var veryTallHeight = "_c2-d";
export var widget = "_c2-6";